export const FLAG_ITINERARY_FOOD_INVOICE_ACTIVITY =
  'FLAG_ITINERARY_FOOD_INVOICE_ACTIVITY';
export const GET_ITINERARY_FOOD_INVOICE = 'GET_ITINERARY_FOOD_INVOICE';
export const CLEAR_ITINERARY_FOOD_INVOICE = 'CLEAR_ITINERARY_FOOD_INVOICE';
export const FLAG_GETTING_ITINERARY_FOOD_INVOICES =
  'FLAG_GETTING_ITINERARY_FOOD_INVOICES';
export const GET_ITINERARY_FOOD_INVOICES = 'GET_ITINERARY_FOOD_INVOICES';
export const CLEAR_ITINERARY_FOOD_INVOICES = 'CLEAR_ITINERARY_FOOD_INVOICES';
